import { useQuery } from '@tanstack/react-query'
import { api } from './api.ts'

export type Bootstrap = Awaited<ReturnType<Awaited<ReturnType<typeof api.catalog.bootstrap.$get>>['json']>>

/**
 * Catalogos configuraveis da instalacao.
 *
 * Uma unica requisicao no boot em vez de uma por catalogo: praticamente toda
 * tela precisa de tipo, status, prioridade e responsavel ao mesmo tempo para
 * renderizar um badge ou um select, e isso viraria uma cascata de chamadas.
 *
 * `staleTime` alto porque catalogo so muda por acao de administrador.
 */
export function useBootstrap() {
  return useQuery({
    queryKey: ['bootstrap'],
    queryFn: async () => (await api.catalog.bootstrap.$get()).json(),
    staleTime: 15 * 60 * 1000,
  })
}

/** Indexa uma lista de catalogo por id, para lookup O(1) na renderizacao. */
export function indexById<T extends { id: string }>(rows: readonly T[] | undefined): Map<string, T> {
  return new Map((rows ?? []).map((row) => [row.id, row]))
}
